import React from "react";
import MonthDayPicker from "../../../components/ComposedForecast/MonthDayPicker";
import type { YearlyRecordSplitArgs } from "../../types";

interface Props {
  args: YearlyRecordSplitArgs;
  onChange: (next: YearlyRecordSplitArgs) => void;
}

const YearlyRecordSplitArgsForm: React.FC<Props> = ({ args, onChange }) => (
  // One column on a phone — each picker is itself two selects, so side by side leaves four in a row
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
    <div>
      <label className="eai-meta-label mb-2 block">Start Date (Month / Day)</label>
      <MonthDayPicker
        value={args.startMonthDay}
        onChange={(startMonthDay) => onChange({ ...args, startMonthDay })}
      />
    </div>
    <div>
      <label className="eai-meta-label mb-2 block">End Date (Month / Day)</label>
      <MonthDayPicker
        value={args.endMonthDay}
        onChange={(endMonthDay) => onChange({ ...args, endMonthDay })}
      />
    </div>
  </div>
);

export default YearlyRecordSplitArgsForm;
